import React from "react";

import style from "./HeavenOnEarth.module.css";

function HeavenOnEarth() {
  return (
    <div className={style.heavenOnEarth}>
      <h2 className={style.heavenOnEarthLabel}>
        Teaching the lifestyle of Faith!!!
      </h2>
    </div>
  );
}

export default HeavenOnEarth;
